{
  "name": "sdr-admin",
  "author": "Releva",
  "version": "1.0.0",
  "description": "SDR Admin",
  "private": true,
  "type": "module",
  "scripts": {
    "dev": "vite",
    "start": "vite preview",
    "build": "vite build",
    "lint": "eslint \"src/**/*.{js,jsx,ts,tsx}\"",
    "lint:fix": "eslint --fix \"src/**/*.{js,jsx,ts,tsx}\"",
    "fm:check": "prettier --check \"src/**/*.{js,jsx,ts,tsx}\"",
    "fm:fix": "prettier --write \"src/**/*.{js,jsx,ts,tsx}\"",
    "rm:all": "rm -rf node_modules .next out dist build",
    "re:start": "yarn rm:all && yarn install && yarn dev",
    "re:build": "yarn rm:all && yarn install && yarn build",
    "re:build-npm": "npm run rm:all && npm install && npm run build",
    "dev:host": "vite --host"
  },
  "dependencies": {
    "@emotion/cache": "^11.11.0",
    "@emotion/react": "^11.11.4",
    "@emotion/styled": "^11.11.5",
    "@fontsource/barlow": "^5.0.13",
    "@fontsource/dm-sans": "^5.0.21",
    "@fontsource/inter": "^5.0.18",
    "@fontsource/nunito-sans": "^5.0.13",
    "@fontsource/public-sans": "^5.0.18",
    "@hookform/resolvers": "^3.6.0",
    "@iconify/react": "^5.0.1",
    "@mui/lab": "^5.0.0-alpha.170",
    "@mui/material": "^5.15.20",
    "@mui/system": "^5.0.2",
    "@mui/x-data-grid": "^7.7.0",
    "@mui/x-date-pickers": "^7.7.0",
    "@mui/x-tree-view": "^7.7.0",
    "@tanstack/react-query": "^5.66.9",
    "@tanstack/react-query-devtools": "^5.66.9",
    "@tiptap/core": "^3.31.3",
    "@tiptap/extension-code-block": "^3.31.3",
    "@tiptap/extension-code-block-lowlight": "^3.31.3",
    "@tiptap/extension-image": "^3.31.3",
    "@tiptap/extension-link": "^3.31.3",
    "@tiptap/extension-placeholder": "^3.31.3",
    "@tiptap/extension-text-align": "^3.31.3",
    "@tiptap/pm": "^3.31.3",
    "@tiptap/react": "^3.31.3",
    "@tiptap/starter-kit": "^3.31.3",
    "@xyflow/react": "^12.5.5",
    "apexcharts": "^4.5.0",
    "autosuggest-highlight": "^3.3.4",
    "axios": "^1.20.0",
    "dayjs": "^1.11.11",
    "framer-motion": "^11.2.10",
    "history": "^5.3.0",
    "i18next": "^23.11.5",
    "i18next-browser-languagedetector": "^8.0.0",
    "i18next-resources-to-backend": "^1.2.1",
    "lowlight": "^3.1.0",
    "mui-one-time-password-input": "^2.0.2",
    "notistack": "^3.0.2",
    "nprogress": "^0.2.0",
    "prop-types": "^15.8.1",
    "react": "^18.3.1",
    "react-apexcharts": "^1.4.1",
    "react-dom": "^18.3.1",
    "react-dropzone": "^14.2.3",
    "react-helmet-async": "^2.0.5",
    "react-hook-form": "^7.51.5",
    "react-i18next": "^14.1.2",
    "react-lazy-load-image-component": "^1.6.0",
    "react-markdown": "^9.0.1",
    "react-phone-number-input": "^3.4.3",
    "react-router-dom": "^6.30.6",
    "rehype-highlight": "^7.0.0",
    "rehype-raw": "^7.0.0",
    "remark-gfm": "^4.0.0",
    "simplebar-react": "^3.2.5",
    "sonner": "^1.5.0",
    "stylis": "^4.3.2",
    "stylis-plugin-rtl": "^2.1.1",
    "swr": "^2.2.5",
    "turndown": "^7.2.0",
    "zod": "^3.23.8",
    "zustand": "^5.0.3"
  },
  "devDependencies": {
    "@eslint/js": "^9.39.2",
    "@types/react": "^18.3.3",
    "@types/react-dom": "^18.3.7",
    "@vitejs/plugin-react-swc": "^4.3.1",
    "eslint": "^9.26.0",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-jsx-a11y": "^6.8.0",
    "eslint-plugin-perfectionist": "^4.15.1",
    "eslint-plugin-prettier": "^5.5.5",
    "eslint-plugin-react": "^7.34.2",
    "eslint-plugin-react-hooks": "^5.2.0",
    "eslint-plugin-unused-imports": "^4.4.1",
    "globals": "^17.3.0",
    "prettier": "^3.3.2",
    "typescript": "^5.4.5",
    "vite": "^8.3.5",
    "vite-plugin-checker": "^0.6.4"
  }
}
